import React from 'react';
import FactChips from '../../../Elements/FactChips';

const facts = [
  { label: 'Client', value: 'Example Car Wash' },
  { label: 'Office', value: 'BARE US' },
  { label: 'Project dates', value: '1 Apr 2026 – 31 Mar 2027' },
  { label: 'Latest invoice', value: '4001302' },
  { label: 'Left out, as it has no value', value: null },
];

function FactChipsDemoComponent() {
  return <FactChips facts={facts} />;
}

export const factChipsDemo = {
  id: 'fact-chips',
  title: 'Fact chips',
  category: 'Basics',
  importPath: 'Elements/FactChips',
  notes: [
    'The facts a page is about, in a wrapping row of design-system chips: the label, then the value in bold.',
    'facts are { label, value }; a value may be an element, such as a link or a user’s name. A fact without a value is left out.',
  ],
  snippet: '<FactChips\n  facts={[{ label: "Client", value: clientName }, { label: "Office", value: officeName }]}\n/>',
  render: FactChipsDemoComponent,
};
